{
  "headings": {
    "start": "Iniciar",
    "end": "Fim",
    "duration": "Dur.",
    "zero": "Zero +/-",
    "activity": "Atividade",
    "location_space": "Localização/Espaço"
  },
  "actions": {
    "insert_row_below": "Inserir linha abaixo",
    "insert_row_below_alt": "Um ícone exibindo a linha de inserção abaixo",
    "insert_row_above": "Inserir linha acima",
    "insert_row_above_alt": "Um ícone exibindo a linha de inserção acima",
    "export_as_excel": "Exportar como Excel"
  },
  "activity": {
    "start": "começa",
    "zero": "TEMPO ZERO"
  },
  "deleting": {
    "deleting_affects_all_instances": "A exclusão afeta todas as instâncias",
    "delete_activity_description_1": "A exclusão dessa atividade também excluirá todas as instâncias em que ela está configurada para se repetir em outros dias.",
    "delete_activity_description_2": "Se você preferir apenas editar as configurações de repetição em vez de excluí-las, clique na coluna inicial"
  },
  "add": {
    "Event unit": "Adicionar item agendado",
    "Activity": "Adicionar atividade"
  },
  "done": "Feito",
  "export_form": {
    "title": "Exportar DCAS",
    "days_to_export": "Dias para exportar",
    "all_days": "Todos os dias",
    "all_days_desc": "Exporte todas as tabelas DCAS para este local em um único arquivo Excel",
    "selected_day": "Dia selecionado",
    "selected_day_desc": "Exportar o DCAS selecionado para um arquivo Excel"
  }
}